export type TGateAnswers = {
  hasLicence?: boolean;
  hasReferrals?: boolean;
};

type TGateOutcome = 'broker' | 'partner' | 'disqualified' | 'incomplete';

export const getGateOutcome = ({
  hasLicence,
  hasReferrals,
}: TGateAnswers): TGateOutcome => {
  if (hasLicence === undefined || hasReferrals === undefined) {
    return 'incomplete';
  }
  if (!hasReferrals) {
    return 'disqualified';
  }
  return hasLicence ? 'broker' : 'partner';
};
